import { LOOKUP_APIS } from '../common/constants/lookups';
import CacheService from '../services/cache';
import { useEffect, useState } from 'react';

const useLookups = (key: string) => {
  const [value, setValue] = useState<any[]>([]);

  useEffect(() => {
    const getValueFromLocalStorage = async () => {
      try {
        const getter = LOOKUP_APIS[key];
        const valueFromLocalStorage = await CacheService.get<any>(key, getter);
        // Callers all treat the result as a list. A malformed cache entry or an unexpected response
        // shape would otherwise be handed straight to .map() and crash the consuming page.
        setValue(Array.isArray(valueFromLocalStorage) ? valueFromLocalStorage : []);
      } catch (error) {
        console.log('Error getting lookup: ', error);
      }
    };

    getValueFromLocalStorage();
  }, [key]);

  return value;
};

export default useLookups;
